<template>
    <section class="card mb-2">
        <FormSection title="Pharmacy" :fullHeight="false">
            <template #content>
                <div class="row m-2">
                    <div class="col-12 col-md-4" v-for="(pharmacy, index) in patientDetails.pharmacies" :key="index">
                        <PatientPharmacy
                            :pharmacy-id="pharmacy"
                            :provider-id="patientDetails.providerId"
                            v-on:updatePharmacyId="updatePharmacyId(index, $event)"
                        ></PatientPharmacy>
                    </div>
                    <div class="col-12 mt-2">
                        <button class="btn btn-outline-primary" @click="addNewPharmacy()">
                            <i class="fas fa-plus"></i> Add Pharmacy
                        </button>
                    </div>
                </div>
            </template>
        </FormSection>
    </section>
</template>

<script lang="ts" src="./Pharmacy.ts"></script>
